import { Attr, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"

@Model()
export class Lab extends ApplicationRecord {
  public static readonly jsonapiType = "labs"

  @Attr() public readonly title!: string

  @Attr() public readonly description!: string

  @Attr() public readonly link!: string

  @Attr() public readonly audience!: "all" | "internal"

  @Attr() public readonly image: string | null = null

  @Attr() public readonly featureFlag: string | null = null
}
